import apiConfig from "../config";
import { AuthRequest, TokenType } from "../../Types/Auth";
import RequestError from "../../Types/RequestError";
import { UserRole } from "../../Types/ProfileUserType";

interface ServerResponse {
	data: RequestSuccessType;
}

interface RequestSuccessType {
	token: TokenType;
	owner: {
		id?: number;
		status?: number;
		firstname?: string;
		surname?: string;
		email?: string;
		roles?: UserRole[];
	};
	loginType?: number;
}

interface RequestResponse extends RequestSuccessType {
	isErr: string | undefined;
}

const registration = ({
	email,
	password,
	rememberMe,
	debounce,
	code,
	allowMarketing,
	nearestRepresentative,
}: AuthRequest): Promise<RequestResponse> => {
	return apiConfig()
		.post<ServerResponse>(`/user/registration`, {
			email: email,
			password: password,
			rememberMe,
			debounce,
			code,
			allowMarketing,
			nearestRepresentative,
		})
		.then(
			({ data }: { data: any }) =>
				({
					isErr: undefined,
					token: data.data.token,
					owner: {
						id: data.data.owner.id,
						status: data.data.owner.status,
						firstname: data.data.owner.firstname,
						surname: data.data.owner.surname,
						email: data.data.owner.email,
					},
					loginType: data.data.loginType,
				} as RequestResponse)
		)
		.catch(
			({ response: { data } }: RequestError) =>
				({
					isErr: data.message,
					token: undefined,
					owner: {
						id: undefined,
						status: undefined,
						firstname: undefined,
						surname: undefined,
						email: undefined,
					},
					loginType: undefined,
				} as RequestResponse)
		);
};

export default registration;
